"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var react_1 = require("react");
var Price_1 = require("../../../../../common/components/prices/price/Price");
var financeQuotePricesStyles_1 = require("./financeQuotePricesStyles");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var FinanceQuotePricesMultiCurrency = function (_a) {
    var labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, primaryPrice = _a.primaryPrice, secondaryPrice = _a.secondaryPrice, className = _a.className;
    var _b, _c, _d, _e;
    var style = financeQuotePricesStyles_1.default();
    return (<core_1.Box className={style.financeQuoteMultiWrapper} component="span">
      {labelBefore}
      <core_1.Box className={style.prices} component="span">
        <Price_1.default price={(_b = primaryPrice) === null || _b === void 0 ? void 0 : _b.value} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={(_c = primaryPrice) === null || _c === void 0 ? void 0 : _c.currency} variant="subtitle1" className={clsx_1.default([style.priceElement, className])} dataTest={'price:finance_quote:primary'}/>
        <core_1.Typography component="span" data-test="cash_price:divider" variant="subtitle1" className={clsx_1.default([style.divider, className])}>
          <Translation_1.default id={'trans__checkout__vehicle_details__price_separator'}/>
        </core_1.Typography>
        <Price_1.default price={(_d = secondaryPrice) === null || _d === void 0 ? void 0 : _d.value} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={(_e = secondaryPrice) === null || _e === void 0 ? void 0 : _e.currency} variant="subtitle1" className={clsx_1.default([style.priceElement, className])} dataTest={'price:finance_quote:secondary'}/>
      </core_1.Box>
      {labelAfter}
    </core_1.Box>);
};
exports.default = FinanceQuotePricesMultiCurrency;
